(function ($) {
    document.addEventListener('filterProducts', wishlistInit)
    document.addEventListener('filterProductsByOrder', wishlistInit)
    document.addEventListener('filterProductsByPrice', wishlistInit)

    "use strict";

    function getSessionStorageItem(key) {
        try {
            return window.sessionStorage ? window.sessionStorage.getItem(key) : null;
        } catch (error) {
            return null;
        }
    }

    function setSessionStorageItem(key, value) {
        try {
            if (window.sessionStorage) {
                window.sessionStorage.setItem(key, value);
            }
        } catch (error) {
            // Storage is optional in restricted browser contexts.
        }
    }

    function removeSessionStorageItem(key) {
        try {
            if (window.sessionStorage) {
                window.sessionStorage.removeItem(key);
            }
        } catch (error) {
            // Storage is optional in restricted browser contexts.
        }
    }

    let loadingAnimation = "<span class='spinner-border'><div></div><div></div></span>";
    let wishlistContainer = jQuery('.wishlist main .content');

    Array.prototype.unique = function () {
        return this.filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
    }

    function isInArray(value, array) {
        return array.indexOf(value) > -1;
    }

    function onWishlistComplete(target, title) {
        setTimeout(function () {
            target
                .removeClass('is-loading')
                .attr('title', title);
        }, 500);
    }

    function highlightWishlist(wishlistIds, title) {
        jQuery('.wishlist-toggle').each(function () {
            let $this = jQuery(this);
            let currentProduct = $this.data('product');
            currentProduct = currentProduct.toString();
            if (isInArray(currentProduct, wishlistIds)) {
                $this.addClass('is-active').attr('title', title);
            }
        });
    }

    let shopName = growtype_wc_ajax.shop_name + '-wishlist',
        inWishlist = growtype_wc_ajax.in_wishlist_text,
        restUrl = growtype_wc_ajax.rest_url,
        wishlistIds = new Array,
        ls = getSessionStorageItem(shopName),
        loggedIn = (jQuery('body').hasClass('logged-in')) ? true : false,
        userData = '';

    if (!loggedIn) {
        if (typeof (ls) != 'undefined' && ls != null) {
            ls = ls.split(',');
            ls = ls.unique();
            wishlistIds = ls;
        }
    }

    if (wishlistContainer.length > 0) {
        fetchWishlistUserData();
    } else {
        wishlistInit();
    }

    function fetchWishlistUserData() {

        wishlistContainer.append(loadingAnimation);

        $.ajax({
            type: 'POST',
            url: growtype_wc_ajax.url,
            data: {
                'action': 'growtype_wc_fetch_user_data',
                'dataType': 'json',
                'wishlist_ids': wishlistIds
            },
            success: function (data) {
                wishlistContainer.find('.spinner-border').remove();

                userData = JSON.parse(data);
                wishlistIds = userData['wishlist_ids'];

                if (wishlistContainer.length > 0) {
                    if (wishlistContainer.find('.products').length === 0) {
                        wishlistContainer.hide().html(userData['wishlist']).fadeIn();
                    } else {
                        wishlistContainer.html(userData['wishlist']);
                    }
                }

                if (loggedIn) {
                    removeSessionStorageItem(shopName);
                }

                wishlistInit();

            },
            error: function () {
            }
        });
    }

    function wishListTrigger($this) {
        $this.on('click', function (e) {
            e.preventDefault();
            if (!jQuery(this).hasClass('is-loading')) {
                jQuery(this).addClass('is-loading');

                if (jQuery(this).hasClass('is-active')) {
                    jQuery(this).removeClass('is-active');

                    if (jQuery('body').hasClass('wishlist')) {
                        jQuery(this).closest('.product').fadeOut().promise().done(function () {
                            jQuery(this).remove();
                        });
                    }

                    for (let i = wishlistIds.length - 1; i >= 0; i--) {
                        if (wishlistIds[i] == jQuery(this).data('product')) {
                            wishlistIds.splice(i, 1);
                        }
                    }
                } else {
                    jQuery(this).addClass('is-active')
                    wishlistIds.push(jQuery(this).data('product').toString());
                }

                wishlistIds = wishlistIds.unique().filter(function (v) {
                    return v !== ''
                });

                if (wishlistIds.length === 0 && wishlistContainer.length > 0) {
                    wishlistContainer.append(loadingAnimation);
                }

                jQuery('.e-wishlist').attr('data-amount', wishlistIds.length)

                if (loggedIn) {
                    $.ajax({
                        type: 'POST',
                        url: growtype_wc_ajax.url,
                        data: {
                            action: 'user_wishlist_update',
                            user_id: userData['user_id'],
                            wishlist_ids: wishlistIds.join(','),
                        }
                    })
                        .done(function (response) {
                            if (wishlistIds.length === 0) {
                                fetchWishlistUserData();
                            }
                        })
                        .fail(function (data) {
                            alert(growtype_wc_ajax.error_text);
                        });
                } else {
                    setSessionStorageItem(shopName, wishlistIds.toString());
                    if (wishlistIds.length === 0) {
                        fetchWishlistUserData();
                    }
                }

                onWishlistComplete($this, inWishlist);
            }
        });
    }

    wishListTrigger(jQuery('.wishlist-toggle'));

    function wishlistInit() {
        if (jQuery('.wishlist-toggle').length === 0) {
            return
        }

        wishlistIds = wishlistIds.filter(function (el) {
            return el != "";
        });

        jQuery('.e-wishlist').attr('data-amount', wishlistIds.length)

        jQuery('.wishlist-toggle').each(function () {
            let $this = jQuery(this);

            if (!loggedIn) {
                let currentProduct = $this.data('product');
                currentProduct = currentProduct.toString();
                if (!loggedIn && isInArray(currentProduct, wishlistIds)) {
                    $this.addClass('is-active').attr('title', inWishlist);
                }
            }

            wishListTrigger($this);
        });
    }

    setTimeout(function () {

        if (wishlistIds.length) {

            restUrl += '?include=' + wishlistIds.join(',');
            restUrl += '&per_page=' + wishlistIds.length;

            $.ajax({
                dataType: 'json',
                url: restUrl
            })
                .done(function (response) {

                })
                .fail(function (response) {
                    alert(growtype_wc_ajax.no_wishlist_text);
                })
        }

    }, 1000);
})(jQuery);
